<template>
  <div id="data-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">

      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="files[0]" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data_localavatar" size="80px" class="mr-4" /> -->
          <div>
            <!-- <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">aaa</p> -->
            <input type="file" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <!-- <vs-button type="border" class="mr-4 mb-4">Change Avatar</vs-button> -->
            <vs-button class="mr-4" @click="$refs.update_avatar_input.click()">Add Profile Picture</vs-button>

            <!-- <vs-button type="border" color="danger">Remove Avatar</vs-button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="InfoIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Account Information</span>
        </div>    
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Email*" v-model="data_local.email" v-validate="'required'" name="email" type="email"/>
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <!-- <vs-input class="w-full mt-4" label="Is Activated" v-model="data_local.is_activated" v-validate="'required'" name="is_activated" />
        <span class="text-danger text-sm"  v-show="errors.has('is_activated')">{{ errors.first('is_activated') }}</span>  -->

        <!-- <vs-input class="w-full mt-4" label="Notes" v-model="data_local.notes" v-validate="'required'" name="notes" />
        <span class="text-danger text-sm"  v-show="errors.has('notes')">{{ errors.first('notes') }}</span> -->   

        <div class="mt-4">
          <label class="vs-input--label">User Role*</label>
          <v-select :options="optionUserRole" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.user_role_id" name="user_role_id" :disabled="this.$route.query.r == 'pmcm' || this.$route.query.r == 'unr'"/>
          <span class="text-danger text-sm"  v-show="errors.has('user_role_id')">{{ errors.first('user_role_id') }}</span>
        </div>

        <div class="mt-4" v-if="userAL > 100">
          <label class="vs-input--label">Parent Org*</label>
          <v-select :options="optionPortfolio" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.pmc_id" name="pmc_id" @change="loadProperty()" @input="loadProperty()"/>
          <span class="text-danger text-sm"  v-show="errors.has('pmc_id')">{{ errors.first('pmc_id') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Property*</label>
          <v-select multiple :options="optionProperty" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.property_id" name="property_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('property_id')">{{ errors.first('property_id') }}</span>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6'"
          name="password"
          label="Password*"          
          placeholder="Password"
          v-model="password"
          class="w-full mt-4" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span> 
        
        <vs-input
          type="password"
          v-validate="'required|min:6|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          placeholder="Confirm Password"
          label="Confirm Password*"
          v-model="confirm_password"
          class="w-full mt-4" />
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
        <div class="flex items-end">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Personal Information</span>
        </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">

            <div class="mt-4">
              <label class="vs-input--label">Salutation</label>
              <v-select :options="optionSalutation" :reduce="name => name.id" label="name" v-model="data_local.salutation_id" name="salutation_id"/>              
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="First Name*" v-model="data_local.first_name" type="first_name" v-validate="'required'" name="first_name" />
              <span class="text-danger text-sm"  v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Middle Name" v-model="data_local.middle_name" type="middle_name" name="middle_name" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Last Name*" v-model="data_local.last_name" type="last_name" v-validate="'required'" name="last_name" />
              <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Suffix" v-model="data_local.suffix" type="suffix" name="suffix" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Phone No*" v-model="data_local.phone1" type="phone1" v-validate="'required'" name="phone1" />
              <span class="text-danger text-sm"  v-show="errors.has('phone1')">{{ errors.first('phone1') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Secondary Phone No" v-model="data_local.phone2" type="phone2" name="phone2" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Date of Birth" v-model="data_local.dob" type="date" name="dob" />              
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Emergency Contact Name" v-model="data_local.emergency_contact_name" name="emergency_contact_name" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Emergency Contact No" v-model="data_local.emergency_contact_no" name="emergency_contact_no" />
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Relation" v-model="data_local.relation" name="relation" />
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/2 mt-4">
        <!-- Col Header -->
          <div class="flex items-end md:mt-0 mt-base">
            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Address</span>
          </div>

        <!-- Col Content -->
        <div>
          <div class="vx-col w-full">
            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 1*" v-model="data_local.address_line_1" type="address_line_1" v-validate="'required'" name="address_line_1" />
              <span class="text-danger text-sm"  v-show="errors.has('address_line_1')">{{ errors.first('address_line_1') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Address Line 2" v-model="data_local.address_line_2" type="address_line_2" name="address_line_2" />
              <span class="text-danger text-sm"  v-show="errors.has('address_line_2')">{{ errors.first('address_line_2') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="State / Province" v-model="data_local.province" type="province" name="province" />
              <span class="text-danger text-sm"  v-show="errors.has('province')">{{ errors.first('province') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="City*" v-model="data_local.city" type="city" v-validate="'required'" name="city" />
              <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>
            </div>
            
            <div class="mt-4">
              <label class="vs-input--label">Country*</label>
              <v-select :options="optionCountry" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.country_id" name="country_id"/>
              <span class="text-danger text-sm"  v-show="errors.has('country_id')">{{ errors.first('country_id') }}</span>
            </div>

            <div class="mt-4">
              <vs-input class="w-full mt-4" label="Postcode*" v-model="data_local.postcode" type="postcode" v-validate="'required'" name="postcode" />
              <span class="text-danger text-sm"  v-show="errors.has('postcode')">{{ errors.first('postcode') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="submit('a')" :disabled="!validateForm">Save and New</vs-button>
          <vs-button class="ml-4 mt-2" @click="submit('b')" :disabled="!validateForm">Save and Close</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'
const jwt = require('jsonwebtoken')
var token = localStorage.usertoken
var decoded = jwt.verify(token, 'secret')

export default {
  components: {
    vSelect
  },
  data () {
    return {
      token: token,
      pmcId: decoded.pmc_id,

      optionSalutation: [],
      optionUserRole: [],
      optionCountry: [],
      optionProperty: [],
      optionPortfolio: [],
      password: '',
      confirm_password: '',
      userAL: null,

      //user
      data_local: {
        email: '',
        first_name: '',
        last_name: '',
        is_activated: '',
        password: '',
        confirm_password: '',
        profile_json: '',
        phone1: '',
        dob: new Date(),
        middle_name: '',
        phone2: '',
        salutation_id: 0,
        suffix: '',
        notes: '',
        avatar_filename: '',
        city: '',
        country_id: 236,
        address_line_1: '',
        province: '',
        address_line_2: '',
        postcode: '',
        user_role_id: this.$route.query.r == 'pmcm' || this.$route.query.r == 'unr' ? parseInt(this.$route.query.rid) : 0,
        property_id: [],
        emergency_contact_name: '',
        relation: '',
        emergency_contact_no: '',
        pmc_id: null
      },

      // uploading docs
      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.password !== '' && this.confirm_password !== ''
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    submit(loc) {
      this.$validator.validateAll()
      .then(result => {
        if(result) {
          this.save_changes(loc)
        }
      })
    },
    save_changes (loc) {       
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      this.data_local.pmc_id = this.$route.query.pmcid === undefined ? this.pmcId : this.$route.query.pmcid
      this.data_local.password = this.confirm_password
      const editId = -1
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/user/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {    
              if(res['data'] != 'access_denied' && res['data'] != '') {

                //uploading docs
                if(res['data']['message'] == 'success') {
                  //uploading docs
                  this.resDataLocal = res['data']['result']

                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully saved'
                  })
                  
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                
                this.$router.push({name:'app-user-list'})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 

            // uploading docs
            await axios.post(`/docs/table/save`, {
              rawFiles: this.rawFiles,
              token: this.token,
              id: this.resDataLocal.id,
              path: `docs/user/avatar/${this.resDataLocal.id}`,
              folderId: 3
            })

            if (this.$route.query.r === 'pmcm') {

              if (this.data_local.user_role_id == 16) {
                // save pmc_manager
                await axios.post(`/portfolio-manager/save/-1`, {              
                  token: this.token,
                  data: {
                    pmc_id: this.data_local.pmc_id,
                    user_id: this.resDataLocal.id
                  }
                })
              }              

              // save property_manager
              await axios.post(`/property-manager/save/-1`, {              
                token: this.token,
                data: {
                  property_id: this.data_local.property_id,
                  user_id: this.resDataLocal.id,
                  pmc_id: this.data_local.pmc_id,
                }
              }) 
            } else if (this.$route.query.r === 'unr') {
              let user_id = []
              user_id[0] = parseInt(this.resDataLocal.id)
              
              // save property_user
              await axios.post(`/property-user/save/-1`, {              
                token: this.token,
                data: {
                  property_id: this.data_local.property_id,
                  user_id: this.resDataLocal.id
                }
              })  

              //save unit_resident
              await axios.post(`/unit-resident/save/-1`, {              
                token: this.token,
                data: {
                  unit_id: parseInt(this.$route.query.unid),
                  user_id: user_id,
                  role_id: parseInt(this.$route.query.rid),
                  property_id: null,
                  resident_type: '',
                  purchase_date: null,
                  move_in_date: null,
                  move_out_date: null,
                  status: '',
                  resident_id: 0,
                  resident_name: '',
                  resident_email: '',
                  resident_phone: '',
                  move_in_note: '',
                  move_out_note: '',
                  is_primary: 0,
                  contact_type: '',
                  role_status: null
                }
              })
            } else {
              // save property_user
              await axios.post(`/property-user/save/-1`, {              
                token: this.token,
                data: {
                  property_id: this.data_local.property_id,
                  user_id: this.resDataLocal.id
                }
              })   

              // save pmc_user
              await axios.post(`/portfolio-user/save/-1`, {              
                token: this.token,
                data: {
                  pmc_id: this.pmcId,
                  user_id: this.resDataLocal.id
                }
              })           
            }

            if (loc=='a') {
              setTimeout(() => {
                window.location.href = "/users/new";
              },500)
            } else {
              if (this.$route.query.r == 'pmcm') {
                this.$router.push({name:'dashboard-analytics'})
              } else {
                this.$router.push({name:'app-user-list'})
              }
            }            
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      //user
      this.data_local['email'] = ''
      this.data_local['first_name'] = ''
      this.data_local['last_name'] = ''
      this.data_local['password'] = ''
      this.data_local['profile_json'] = ''
      this.data_local['phone1'] = ''
      this.data_local['dob'] = ''
      this.data_local['middle_name'] = ''
      this.data_local['phone2'] = ''
      this.data_local['salutation_id'] = ''
      this.data_local['suffix'] = ''
      this.data_local['notes'] = ''
      this.data_local['city'] = ''
      this.data_local['country_id'] = ''
      this.data_local['address_line_1'] = ''
      this.data_local['province'] = ''
      this.data_local['address_line_2'] = ''
      this.data_local['postcode'] = ''
      this.data_local['user_role_id'] = ''
      this.data_local['property_id'] = ''      
      this.data_local['pmc_id'] = ''      
      
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    // uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    // uploading docs
    async update_avatar () {
      this.$vs.loading()

      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      this.files = []
      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    async loadUserPem() {
      const viewId = decoded.id
      var d = await axios.get(`/user/view/${viewId}`, {
        headers: { 'Authorization': this.token }
      }) 
      this.userAL = d['data'][0]['user_role']['access_level']

      console.log('this.userAL ', this.userAL > 100)
      console.log('this.userAL ', this.data_local.pmc_id)
    },
    loadSalutation () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/salutation/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res salutation ', res)
        this.optionSalutation = res
      })
    },
    loadCountry () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/country/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res country ', res)
        this.optionCountry = res
      })
    },
    loadUserRole () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/userRole/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res user role ', res)
        this.optionUserRole = res
      })
    },
    loadProperty () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          this.data_local.pmc_id = this.userAL > 100 ? null : this.pmcId
          await axios.get(`/property/pmc/list`, {
              headers: { 'Authorization': this.token, pmc_id: this.data_local.pmc_id }
            })
            .then(res => {    
              this.data_local['property_id'] = null
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res property ', res)
        this.optionProperty = res
      })
    },
    loadParentOrg () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/portfolio/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res portfolio ', res)
        this.optionPortfolio = res
      })
    }
  },
  created () {
    this.loadSalutation()
    this.loadCountry()
    this.loadUserRole()
    this.loadProperty()
    this.loadParentOrg()
    this.loadUserPem()
  }
}
</script>
